/* External */
import throttleL from "lodash/throttle";
import { createStore, applyMiddleware, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

/* Others */
import { loadState, saveState } from "./localStorage";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

const enableReduxDevTools = process.env.NODE_ENV === "development" || process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS;
const composeEnhancers = enableReduxDevTools ? composeWithDevTools : compose;
const preloadedState = loadState();
const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(sagaMiddleware)));

store.subscribe(
  throttleL(() => {
    const { global, isBannerShown, user, audioAndSubtitlesPreferences } = store.getState();
    saveState({
      global,
      isBannerShown,
      user,
      audioAndSubtitlesPreferences
    });
  }, 1000)
);

sagaMiddleware.run(rootSaga);

export default store;
